import { atom } from 'jotai';
import { atomFamily } from 'jotai-family';
import { atomWithReset } from 'jotai/utils';

import type { ScoringRunState } from '@/types/scoringRun';

/** Set of ids for scoring runs currently being polled. */
export const pollingScoringRunIdsAtom = atomWithReset<Set<string>>(new Set<string>());

/** Atom recording the scoring run status for each survey. */
export const scoringRunAtomFamily = atomFamily((_surveyId: string) =>
  atom<ScoringRunState | null>(null)
);

/** Atom storing the last error encountered when attempting to poll a scoring run's status. */
export const scoringRunErrorAtom = atomWithReset<Error | null>(null);